import React from 'react';
import Layout from '../components/layout/Layout';
import HeroSection from '../components/home/HeroSection';
import AboutSection from '../components/home/AboutSection';
import WhyChooseUsSection from '../components/home/WhyChooseUsSection';
import ServicesSection from '../components/home/ServicesSection';
import IndustriesSection from '../components/home/IndustriesSection';
import InstagramSection from '../components/home/InstagramSection';
import CTASection from '../components/home/CTASection';

const HomePage = () => {
  return (
    <Layout>
      <HeroSection />
      <AboutSection />
      <WhyChooseUsSection />
      <ServicesSection />
      <IndustriesSection />
      <InstagramSection />
      <CTASection />
    </Layout>
  );
};

export default HomePage;
